<template lang="pug">
  .full-image
    .observer
      lazy-component(@show="show")
        img(:src="image.src")
    figure.image(
      :style="{ 'height': `${height}px`, 'background-image': `url(${image.loading})` }"
      :class="{ loaded }"
    )
      img(
        :src="image.src"
        :class="{ loaded }"
      )
</template>

<script>
import PreviewImage from './PreviewImage';
export default {
    name: 'FullImage',
    extends: PreviewImage,
    computed: {
        image() {
            let image = this.media.image;

            let root = '';
            const endpoint = `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}`;
            if (process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE) root = process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE;
            const base = endpoint + root + 'images/';

            return {
                src: `${base}${image.id}/${image.name}?fit&w=${this.width}&format=webp`,
                error: `${base}${image.id}/${image.name}?fit&w=${this.width}&preview=greyscale`,
                loading: `${base}${image.id}/${image.name}?fit&w=${this.width}&preview=blur`
            };
        }
    }
};
</script>

<style lang="sass" scoped>
.observer
  display: absolute
  width: 0
  height: 0
  left: -300vw
.image
  @apply bg-gray-200
  background-position: center
  background-repeat: no-repeat
  background-size: cover
  width: 100%
  // &.loaded
  //   height: auto !important
  img
    opacity: 0
    width: 100%
    transition: opacity .3s ease
    &.loaded
      opacity: 1
</style>
